export interface SprKey {
  SupplierGsdb: string;
  PlantGsdb: string;
}

export const sprKeysAreEqual = (left: SprKey, right: SprKey) => {
  return left.SupplierGsdb === right.SupplierGsdb && left.PlantGsdb === right.PlantGsdb;
};

export const sprKeyIsInValid = (sprKey: SprKey) => {
  return sprKey.SupplierGsdb.trim() === "" || sprKey.PlantGsdb.trim() === "";
};
